import React, { useState } from "react";
import ACSHelper from "./ACSHelper";
import { SignInButton } from "./SignInButton";
import { Stack, Text } from "@fluentui/react";
import {
  containerStyle,
  headerStyle,
  containerTokens,
} from "../styles/HomeScreen.styles";
import { useGlobalState, GlobalStateInterface } from "../utils/GlobalState";
import LoginBanner from "./LoginBanner";

const Login = (): JSX.Element => {
  const { setState } = useGlobalState();

  function loadMeetingId() {
    const params = new URLSearchParams(window.location.search);
    if (params.has("meetingId")) {
      let id = params.get("meetingId")!;
      localStorage.setItem("meetingId", id);
      setState((prev) => {
        return { ...prev, meetingId: id };
      });
    } else {
      setState((prev) => {
        return { ...prev, meetingId: "" };
      });
    }
  }

  React.useEffect(() => {
    loadMeetingId();
  }, []);

  return (
    <>
      <Stack
        horizontal
        wrap
        horizontalAlign="center"
        verticalAlign="center"
        className={containerStyle}
        tokens={containerTokens}
      >
        <LoginBanner />
      </Stack>
      <Stack
        horizontal
        wrap
        horizontalAlign="center"
        verticalAlign="center"
        className={containerStyle}
        tokens={containerTokens}
      >
        <SignInButton />
      </Stack>
    </>
  );
};

export default Login;
